<template>
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="transform rotate-180"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0" />

    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      <path
        d="M8.43934 15.9393C9.02513 15.3536 9.97487 15.3536 10.5607 15.9393L24 29.3787L37.4393 15.9393C38.0251 15.3536 38.9749 15.3536 39.5607 15.9393C40.1464 16.5251 40.1464 17.4749 39.5607 18.0607L25.0607 32.5607C24.4749 33.1464 23.5251 33.1464 22.9393 32.5607L8.43934 18.0607C7.85355 17.4749 7.85355 16.5251 8.43934 15.9393Z"
        fill="#1eff00"
      />
    </g>
  </svg>
</template>
<script setup></script>
